'use strict';

const i18n = require('i18next');
const _ = require('underscore');
const Mn = require('backbone.marionette');
require('backbone.stickit');
const ElementCommunication = require('./element-communication');
const ElementAction = require('system/domain/action/element');
const LinkModel = require('system/domain/entity/link');
const SyncStatesModel = require('system/domain/entity/sync-states');
const MarkdownWriterView = require('common/ui/view/markdown/writer');
const SyncStateView = require('system/ui/view/sync-state');
const LinkDeleteModalView = require('system/ui/view/modal/link-delete');
const Template = require('system/ui/template/detail/link-edit.hbs');

const LinkEditView = Mn.View.extend({
    model: LinkModel,
    template: Template,
    className: 'link-edit',
    ui: {
        name: '.name input',
        multiplicity: '.multiplicity input'
    },
    regions: {
        description: '.description',
        syncState: '.sync-states',
        nav: '.nav',
        navContent: '.nav-content'
    },
    events: {
        'click .cancel-edit': 'cancelEdit',
        'click .link-menu-change-type': 'changeType',
        'click .link-menu-delete': 'delete',
        'click .link-menu-novend': 'novend',
        'click .link-menu-invert': 'invert',
        'click .move-to': 'moveTo',
        'click .close-pane': function(){this.trigger('hide')},
        'input @ui.name': 'name',
        'input @ui.multiplicity': 'setMultiplicity',
        'change @ui.multiplicity': 'setMultiplicity'
    },

    initialize: function(params) {
        _.bindAll(this, 'save');

        this._diagram = params.diagram;
        this._context = params.context;
        this._members = params.members;
        this._channel = this.getOption('channel');

        this.listenTo(this.model, 'change:edit', this.trigger.bind(this, 'change:edit'));
        this.listenTo(this.model.syncState,
            'change:state', function() {
                if(this.model.syncState.isConflict()) {
                    this.render();
                }
            });
    },

    serializeData: function() {
        const json = this.model.toJSON();
        let typeChangeable = true;
        let cancelable = !this.model.get('creating');
        let deletable = true;
        // コンフリクトしている場合は色々禁止
        if(this.model.syncState.isConflict()) {
            typeChangeable = false;
            cancelable = false;
            deletable = false;
        }
        json['type'] = this.model.i18nType();
        json['typeChangeable'] = typeChangeable;
        json['cancelable'] = cancelable;
        json['deletable'] = deletable;
        json['multiplicity'] = this.model.get('multiplicity');

        return json;
    },

    onRender: function() {
        const project = this.getOption('project');

        // description
        this._writer = new MarkdownWriterView({
            project: project,
            markdown: this.model.get('description'),
            placeholder: i18n.t('diagram:model.link.description.placeholder'),
        });

        this.listenTo(this._writer, 'change', function(desc){
            this.update({description: desc});
        });
        this.getRegion('description').show(this._writer);

        // sync state
        const syncStateView = new SyncStateView({
            model: new SyncStatesModel({
                models: [
                    this.model.syncState,
                    this._diagram.getLinkMeta(
                        this.model.id).syncState
                ]
            })
        });
        syncStateView.on('sync:start', this.save);
        this.listenTo(syncStateView, 'resync:start', function(){
            ElementAction.resyncLink({
                context: this._context,
                link: {id: this.model.id}
            })
        });
        this.getRegion('syncState').show(syncStateView);

        this.stickit();

        this.linkDeleteModal = new LinkDeleteModalView({
            model: this.model,
            context: this._context
        });
        $('#modal-container').append(
            this.linkDeleteModal.render().el);

        this.showChildView('navContent', new ElementCommunication({
            model: this.model,
            context: this.getOption('newContext'),
            parentContent: this.$('.content'),
            navRegion: this.getRegion('nav')
        }));

        return this;
    },

    onDomRefresh: function() {
        $.material.init();
    },

    update: function(j) {
        if(this.model.syncState.isConflict()) {
            return;
        }

        j.id = this.model.id;
        ElementAction.updateLink({
            context: this._context,
            link: j
        });
    },

    name: function() {
        this.update({name: this.ui.name.val()})
    },

    setMultiplicity: function() {
        const multiplicity = {};
        let hasError = false;
        _.each(['source', 'target'], function(edge) {
            const lower = this.$(`.multiplicity .${edge} .lower`).val();
            const upper = this.$(`.multiplicity .${edge} .upper`).val();
            const noUpperLim = this.$(`.multiplicity .${edge} .no-upper-limit`).is(`:checked`);
            this.$(`.multiplicity .${edge} .upper`).attr(`disabled`, noUpperLim);

            const error = this.validateMultiplicity(lower, upper, noUpperLim);
            if(error) {
                hasError = true;
                this.$(`.multiplicity .${edge} .error-message`).text(error);
                return;
            } else {
                this.$(`.multiplicity .${edge} .error-message`).text(``);
            }

            multiplicity[edge] = {
                lower: parseInt(lower, 10),
                upper: noUpperLim ? null : parseInt(upper, 10)
            };
        }, this);

        if(hasError){
            return;
        }

        this.update({multiplicity: multiplicity})
    },

    validateMultiplicity: function(lower, upper, noUpperLim) {
        const l = parseInt(lower, 10);
        if(_.isNaN(l)) {
            return i18n.t('view/diagram:linkEdit.multiplicity.error.lowerIsNaN');
        }
        if(l < 0) {
            return i18n.t('view/diagram:linkEdit.multiplicity.error.lowerInvalid');
        }
        if(noUpperLim) {
            return null;
        }
        const u = parseInt(upper, 10);
        if(_.isNaN(u)) {
            return i18n.t('view/diagram:linkEdit.multiplicity.error.upperIsNaN');
        }
        if(u < 1) {
            return i18n.t('view/diagram:linkEdit.multiplicity.error.upperInvalid');
        }
        if(l > u) {
            return i18n.t('view/diagram:linkEdit.multiplicity.error.lowerIsLarger');
        }
        return null;
    },

    save: function() {
        const j = {context: this._context};
        const meta = this._diagram.getLinkMeta(this.model.id);
        if(meta.syncState.isUnsync()) {
            j.metas = {links: {}};
            j.metas.links[this.model.id] = meta.toJSON();
        }
        if(this.model.syncState.isUnsync()) {
            j.models = {
                links: [this.model.toJSON()]
            }
        }
        ElementAction.saveElements(j);
    },

    cancelEdit: function() {
        if(this.model.get('creating')) {
            return;
        }
        ElementAction.cancelEditLink({
            context: this._context,
            link: {id: this.model.id}
        });
    },

    changeType: function() {
        this._channel.request('canvas:changeLinkType', this.model);
    },

    delete: function() {
        this.linkDeleteModal.show();
    },

    moveTo: function() {
        this._channel.request('canvas:zoomTo', this.model);
    },

    novend: function() {
        ElementAction.updateLink({
            context: this._context,
            linkMeta: {
                id: this.model.id,
                vendAt: null
            }
        });
    },

    invert: function() {
        ElementAction.invertLink({
            context: this._context,
            link: [this.model.toJSON()]
        });
    }
});

module.exports = LinkEditView;



// WEBPACK FOOTER //
// ./system/ui/view/detail/link-edit.js